// Functions to talk to the Android Native side.
// This was adapted from: https://github.com/stitchfix/hellblazer/blob/8b241951c24a13783cf80d750865b8327ffc14a8/app/assets/javascripts/android.js#L11-L53

const getAndroidApp = () =>
  typeof window === 'object' && window.StitchFixAndroidApp;

/**
 * Returns whether or not the the browser is being embedded within the Android app
 * by testing to see if the Android native bridge exists
 * @returns {boolean}
 */
export const isAndroidApp = () => typeof getAndroidApp() === 'object';

/**
 * Log in with Facebook using native Android SDK
 *
 */
export const loginWithFacebook = (permissions: string) => {
  // NOTE: The first two params are `path` & `action` which Android takes
  // and passes back to us (when it calls `window.stitchfix.AndroidAPI.handleFacebookLogin`
  // that is defined in the UI). These values are not configurable,
  // so what we pass to Android doesn't really matter.
  const androidApp = getAndroidApp();

  if (!androidApp) {
    return;
  }

  androidApp?.loginWithFacebook?.('', '', permissions);
};

/**
 * Log in with Google using native Android SDK
 */
export const loginWithGoogle = (clientId: string, scopes: string) => {
  const androidApp = getAndroidApp();

  if (!androidApp) {
    return;
  }

  androidApp?.loginWithGoogle?.(clientId, scopes);
};
